import React, { createContext, useContext, useState, useCallback } from 'react';

const MockDateContext = createContext({
  mockDate: null,
  isMocked: false,
  getNow: () => new Date(),
  nowMs: () => Date.now(),
  setMockDate: () => {},
  clearMock: () => {},
});

export const MockDateProvider = ({ children }) => {
  const [mockDate, setMockDateState] = useState(null);

  const setMockDate = useCallback((year, month, day = 15) => {
    // Clamp day to valid range for that month
    const maxDay = new Date(year, month + 1, 0).getDate();
    const safeDay = Math.min(Math.max(1, day), maxDay);
    setMockDateState(new Date(year, month, safeDay, 12, 0, 0, 0));
  }, []);

  const clearMock = useCallback(() => setMockDateState(null), []);

  const getNow  = useCallback(() => mockDate ? new Date(mockDate) : new Date(), [mockDate]);
  const nowMs   = useCallback(() => mockDate ? mockDate.getTime() : Date.now(), [mockDate]);

  return (
    <MockDateContext.Provider value={{
      mockDate,
      isMocked: !!mockDate,
      getNow,
      nowMs,
      setMockDate,
      clearMock,
    }}>
      {children}
    </MockDateContext.Provider>
  );
};

export const useMockDate = () => useContext(MockDateContext);
export default MockDateContext;
